import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { FinalizeDealInInventorySystemResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export const finalizeDealInInventorySystem = async (
	servicesProviderId: string,
	orderId: string,
): Promise<FinalizeDealInInventorySystemResponse> => {
	const response = await apiClient.post<FinalizeDealInInventorySystemResponse>(
		ordersEndpoints.finalizeDealInInventorySystem(servicesProviderId, orderId),
		{}, // Empty body as per backend schema
	);
	return response.data;
};

export const useFinalizeDealInInventorySystem = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async () => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to finalize deal in inventory system without an order ID or services provider ID.',
				);
			}

			return finalizeDealInInventorySystem(servicesProviderId, orderId);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.FINALIZE_DEAL_IN_INVENTORY_SYSTEM);
		},
	});
};
